import { isElectronRuntime } from '../realm/isRealmEnabled';

export const decodeShareMarkup = (value) => String(value || '')
  .replace(/&amp;/gi, '&')
  .replace(/&lt;/gi, '<')
  .replace(/&gt;/gi, '>')
  .replace(/&quot;/gi, '"')
  .replace(/&#39;/g, "'")
  .replace(/<[^>]*>/g, ' ');

const matchQueryParam = (text, name) => {
  const match = String(text || '').match(new RegExp(`[?&#]${name}=([^&\\s#"']+)`, 'i'));
  if (!match) return '';
  try {
    return decodeURIComponent(String(match[1] || '').trim());
  } catch {
    return String(match[1] || '').trim();
  }
};

export const parseChatThreadShareFromText = (value) => {
  const text = decodeShareMarkup(value);
  if (!text || /[?&#](workflow|task)=/i.test(text)) return null;
  const messageId = matchQueryParam(text, 'messageId');
  if (!messageId) return null;
  return {
    channelId: matchQueryParam(text, 'channelId'),
    messageId,
    threadId: matchQueryParam(text, 'threadId'),
  };
};

export const resolveChatThreadShare = (msg) => (
  parseChatThreadShareFromText(msg?.linkPreview?.url)
  || parseChatThreadShareFromText(msg?.content)
);

export const buildChatThreadShareUrl = ({ channelId, messageId, threadId }) => {
  const id = String(messageId || '').trim();
  if (!id) return '';
  const params = new URLSearchParams();
  if (channelId) params.set('channelId', String(channelId).trim());
  params.set('messageId', id);
  if (threadId && String(threadId).trim() && String(threadId) !== id) {
    params.set('threadId', String(threadId).trim());
  } else if (threadId && String(threadId) === id) {
    params.set('threadId', id);
  }
  const query = params.toString();
  if (typeof window === 'undefined') return `/chat?${query}`;
  if (isElectronRuntime()) {
    const path = window.location.pathname || '/';
    return `${window.location.origin}${path}#/chat?${query}`;
  }
  return `${window.location.origin}/chat?${query}`;
};
